import React from 'react';
import BaseFilter from './base_filter';
import FilterSelect from '../partners/filter_select';
import { SHAPES, FILTER_OPTIONS } from './filter_constants_and_helpers';
import _ from "lodash";

class ShapeDropdownFilter extends BaseFilter {

    constructor(props) {
        super(props)

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)

        // get visible options from all options.
        this.options = SHAPES.jewelry.map(e => {
            return FILTER_OPTIONS.shapes.all.find(s => s.pretty_name === e)
        })

        this.updateByItemProp = true

        this._setFiltersInternal = this._setFiltersInternal.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    removeFilter(name) {
        if ( name ) {
            this._setFiltersInternal(ShapeDropdownFilter.getFilterName(),this._dropDownRemoveFilter(name," " + this._getFilterName()))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {in:[]}
    }

    _setDefault() {
        this.setFilters(ShapeDropdownFilter.getFilterName(),this._defaultValue())
    }

    _setFiltersInternal(filterName,newValue) {
        this.setFilters(filterName,{in:newValue},this.removeFilter)
    }

    _itemValue(itemFilters) {
        return {in: itemFilters && itemFilters.shape || []}
    }

    _render() {
        return <div><FilterSelect
            label={"Shape"}
            name={ShapeDropdownFilter.getFilterName()}
            options={this.options}
            route={"recent_deals_"+this.props.itemType}
            selectedOptions={this.state.in}
            setFilters={this._setFiltersInternal}
            systemName={ShapeDropdownFilter.getFilterName()}
        />
        </div>
    }

    _getFilterValue() {
        return {in:this.state.in}
    }

    _getFilterName() {
        return ShapeDropdownFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of newState.in ) {
            let option = this.options.find(e => e.id == id)
            if (option) tagList.push(option.pretty_name + " " + this._getFilterName())
        }
        return tagList
    }

    _apiKeys() {
        return ["in"]
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "shape"
    }
}

export default ShapeDropdownFilter;